<template>
    <div class="card singleUserCard" v-click-outside="onClickOutside">
        <div :class="[[0,1,2,3].indexOf(index) >=0 ? `triangle-${getUsersLength.length-index}` : 'triangle']"></div>
        <div class="card-body">
            <div class="topDiv">
                <div class="showSingleUserCircle"
                     v-bind:class="{'nameInitialsCircleSelf': user.uuid && user.uuid === $store.getters.firebaseUser.uid}">
                    <div class="userInitials">{{tools.userInitial(user)}}</div>
                </div>
                <div class="name">{{user.name}}</div>
                <template v-if="canEditMethod(user)">
                    <button class="userCard-edit"
                            v-on:click="$parent.editUser(user, title)">
                        <i class="fas fa-pen"></i>
                        <span class="sr-only">Edit</span>
                    </button>
                </template>
                <template v-else-if="canPatchMethod(user)">
                    <button class="userCard-edit"
                            v-on:click="$parent.patchUser(user, title)">
                        <i class="fas fa-pen"></i>
                        <span class="sr-only">Edit</span>
                    </button>
                </template>
            </div>
            <dl class="card-text clearfix">
                <dt class="cardInfo">Title:</dt>
                <dd class="cardDescription">{{title ? title : 'N/A'}}</dd>
                <dt class="cardInfo">Role:</dt>
                <dd class="cardDescription">{{buildingRole.display_name}}
                    <ToolTip>
                        <sup class="superScript">
                            <i class="fas fa-info-circle"
                               data-toggle="tooltip"
                               data-placement="top"
                               data-html="true"
                               title=""
                               v-bind:data-original-title="this.tipes[buildingRole.name]"></i>
                        </sup>
                    </ToolTip>
                </dd>
                <template v-if="canEdit">
                    <dt class="cardInfo">Email:</dt>
                    <dd class="cardDescription">{{user.email}}</dd>
                </template>
                <template v-else-if="user.uuid === this.$store.getters.firebaseUser.uid">
                    <dt class="cardInfo">Email:</dt>
                    <dd class="cardDescription">{{user.email}}</dd>
                </template>
                <dt class="cardInfo" v-if="user.id ===null">Status:</dt>
                <dd class="cardDescription" v-if="user.id ===null">Invitation Sent</dd>
            </dl>
        </div>
    </div>
</template>
<script>
  import Tools from '@/app-model/tools.js';
  import User from '@/app-model/user.js';
  import ToolTip from '@/components/tool-tip/ToolTip.vue';
  import vClickOutside from 'v-click-outside'

  export default {
    props: {
      user: Object,
      title: String,
      buildingRole: Object,
      index: [String, Number],
      buildingId: [String, Number],
      users: Array
    },
    data () {
      return {
        editUserCard: false,
        tipes: {
          'read': 'Access to read all information associated with a building.',
          'write': 'All permissions from the Read role, as well as access to modify all information and settings associated with a building.',
          'building admin': 'All permissions from the Write role, as well as the ability to invite other users to the building and modify the role of existing users.',
          'wbs staff': 'All permissions from the Admin role, as well as the ability to control devices activation, installation date.'
        }
      }
    },
    components : {
      ToolTip
    },
    mounted () {
      jQuery($('[data-toggle="tooltip"]').tooltip());
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    methods: {
      onClickOutside (event) {
        if(event.target.className !== 'userInitials'
          && event.target.className !== 'nameInitialsCircle'
        ) {
          this.$emit('close',undefined)
        }
      },
      canEditMethod (user) {
        if (user.id === null) return false;
        return !user.user_role_id && this.canEdit && user.uuid !== this.$store.getters.firebaseUser.uid;
      },
      canPatchMethod (user) {
        if (user.id === null) return false;
        return !user.user_role_id && this.canEdit && user.uuid === this.$store.getters.firebaseUser.uid;
      },
    },
    computed: {
      tools: function() {
        return new Tools;
      },
      userModel: function() {
        return new User;
      },
      canEdit () {
        return this.userModel.canUpdateUserBuildingRole({store: this.$store, buildingId: this.buildingId});
      },
      getUsersLength () {
        if (this.users.length > 4) {
          return this.users.slice(0, 4)
        }
        return this.users
      },
    }
  }
</script>
<style lang="scss" scoped>
    @import "@/../sass/_users.scss";
</style>